<template>
<v-lazy :options="{'threshold':1}" v-model="loading">
  <div class="w-100 bg-white pa-5 position-relative mt-5" v-if="products.length > 0">
    <v-row>
      <v-col class="v-col-12">
        <h3 class="text-color-1 font-weight-bold mb-3">PRODUTOS RELACIONADOS</h3>
      </v-col>
      <v-col class="v-col-1 d-none d-lg-flex align-center justify-center pa-0">
        <v-btn @click="prev" icon="mdi-chevron-left" variant="tonal" size="large" flat :color="'var(--color-default)'" class="text-huge"></v-btn>
      </v-col>
      <v-col class="v-col-12 v-col-lg-10 d-flex align-center justify-center pa-0">
        <Carousel ref="carousel" :settings="settings" :breakpoints="breakpoints" v-if="products != null" class="carousel-product">
          <Slide v-for="(slide, index) in products" :key="index">
            <Product :product="slide" :notImage="true"></Product>
          </Slide>
        </Carousel>
      </v-col>
      <v-col class="v-col-1 d-none d-lg-flex align-center justify-center pa-0">
        <v-btn @click="next" icon="mdi-chevron-right" variant="tonal" size="large" flat :color="'var(--color-default)'" class="text-huge"></v-btn>
      </v-col>
    </v-row>
  </div>
</v-lazy>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';
import Product from './Product.vue';
import ImageProduct from '@/components/ImageProduct.vue';
import { mapActions } from 'vuex';
import { capitalize } from '@/store/services/utils.js';

export default {
  name: 'CarouselRelated',
  components: {
    Carousel,
    Slide,
    Product,
    ImageProduct
  },
  props: {
    barcode: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      loading: true,
      products: [],
      settings: {
        itemsToShow: 1.2,
        snapAlign: 'start',
      },
      breakpoints: {
        700: {
            itemsToShow: 2,
            snapAlign: 'start',
        },
        1280: {
            itemsToShow: 3,
            snapAlign: 'start',
        },
        1500: {
            itemsToShow: 4,
            snapAlign: 'start',
        },
        1800: {
            itemsToShow: 5,
            snapAlign: 'start',
        },
      },
    }
  },
  methods: {
    ...mapActions('products', {
      getProdutosRelacionados: 'getProdutosRelacionados',
      getImageCarousel: 'getImageCarousel'
    }),
    capitalize,
    next() {
      this.$refs.carousel.slideTo(this.$refs.carousel.data.currentSlide._value + this.$refs.carousel.data.config.itemsToShow);
    },
    prev() {
      this.$refs.carousel.slideTo(this.$refs.carousel.data.currentSlide._value - this.$refs.carousel.data.config.itemsToShow);
    }
  },
  mounted(){
    if(this.barcode){
      this.getProdutosRelacionados({ barcode: this.barcode}).then(function(response){
        this.products = response;
        this.products.forEach((element) => {
          this.getImageCarousel({ sku: element.sku, imghash: "t-"+element.imghash }).then(function(image){
            element.image = image;
          }.bind(this));
        });
        this.loading = false;
      }.bind(this));
    }
  }
}
</script>